import {defaultLang} from './default';
import {enLang} from './en.js';
import {esLang} from './es.js';
export const getLang = (lang) => {
    let overrideLang;
    switch (lang) {
        case 'en':
            overrideLang = enLang;
            break;
        case 'es':
            overrideLang = esLang;
            break;
        default:
            overrideLang = {};
    }

    return {
        ...defaultLang,
        ...overrideLang
    }
}